// extracted by mini-css-extract-plugin
module.exports = {"Container":"drawer-content_Container__ozBaZ"};